import { createReducer } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

import {
  MESSAGES_DETAIL_RESET,
  MESSAGES_DETAIL_GET_START,
  MESSAGES_DETAIL_GET_SUCCESS,
  MESSAGES_DETAIL_GET_FAILURE,
  MESSAGES_SET_READ_REQUEST,
  MESSAGES_SET_READ_SUCCESS,
  MESSAGES_SET_READ_FAILURE,
  MESSAGES_SET_ARCHIVED_REQUEST,
  MESSAGES_SET_ARCHIVED_SUCCESS,
  MESSAGES_SET_ARCHIVED_FAILURE,
  MESSAGES_ADD_PARTICIPANTS_REQUEST,
  MESSAGES_ADD_PARTICIPANTS_SUCCESS,
  MESSAGES_ADD_PARTICIPANTS_FAILURE,
} from './messagesDetail.const';

export const initialState = {
  model: {},
  meta: {
    errorMessage: '',
    status: null,
    readStatus: null,
    archiveStatus: null,
    participantsStatus: null,
  },
};

const messagesDetailReducer = createReducer(initialState, builder => {
  builder
    .addCase(MESSAGES_DETAIL_RESET, () => initialState)
    .addCase(MESSAGES_DETAIL_GET_START, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    })
    .addCase(MESSAGES_DETAIL_GET_SUCCESS, (state, { payload = {} }) => {
      state.model = payload;
      state.meta.status = STATUS.SUCCESS;
    })
    .addCase(MESSAGES_DETAIL_GET_FAILURE, (state, { payload = {} }) => {
      state.model = {};
      state.meta.errorMessage = payload.errorMessage;
      state.meta.status = STATUS.ERROR;
    })
    .addCase(MESSAGES_SET_READ_REQUEST, state => {
      state.meta.readStatus = STATUS.UPDATING;
    })
    .addCase(MESSAGES_SET_READ_SUCCESS, (state, { payload = {} }) => {
      state.model.isRead = payload.read;
      state.meta.readStatus = STATUS.SUCCESS;
    })
    .addCase(MESSAGES_SET_READ_FAILURE, state => {
      state.meta.readStatus = STATUS.ERROR;
    })
    .addCase(MESSAGES_SET_ARCHIVED_REQUEST, state => {
      state.meta.archiveStatus = STATUS.UPDATING;
    })
    .addCase(MESSAGES_SET_ARCHIVED_SUCCESS, (state, { payload = {} }) => {
      state.model.isArchived = payload.archived;
      state.meta.archiveStatus = STATUS.SUCCESS;
    })
    .addCase(MESSAGES_SET_ARCHIVED_FAILURE, state => {
      state.meta.archiveStatus = STATUS.ERROR;
    })
    .addCase(MESSAGES_ADD_PARTICIPANTS_REQUEST, state => {
      state.meta.participantsStatus = STATUS.UPDATING;
    })
    .addCase(MESSAGES_ADD_PARTICIPANTS_SUCCESS, (state, { payload = {} }) => {
      state.model.participants = payload.usersDetail;
      state.meta.participantsStatus = STATUS.SUCCESS;
    })
    .addCase(MESSAGES_ADD_PARTICIPANTS_FAILURE, state => {
      state.meta.participantsStatus = STATUS.ERROR;
    })
    .addDefaultCase(() => {});
});

export default messagesDetailReducer;
